import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import {
	PORTAL_SOURCE_QUERY_PARAM,
	PORTAL_SOURCE_WP_STORAGE_KEY,
	PORTAL_SOURCE_WP_VALUE,
} from "@constants/portalSourceWp.constants";

const PortalSourceWpContext = createContext(false);

export function PortalSourceWpProvider({ children }: { children: ReactNode }) {
	const location = useLocation();
	const [isActive, setIsActive] = useState(() =>
		typeof window !== "undefined" ? sessionStorage.getItem(PORTAL_SOURCE_WP_STORAGE_KEY) === "1" : false,
	);

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		if (params.get(PORTAL_SOURCE_QUERY_PARAM) === PORTAL_SOURCE_WP_VALUE) {
			sessionStorage.setItem(PORTAL_SOURCE_WP_STORAGE_KEY, "1");
		}
		setIsActive(sessionStorage.getItem(PORTAL_SOURCE_WP_STORAGE_KEY) === "1");
	}, [location.pathname, location.search]);

	return <PortalSourceWpContext.Provider value={isActive}>{children}</PortalSourceWpContext.Provider>;
}

export function usePortalSourceWp(): boolean {
	return useContext(PortalSourceWpContext);
}
